import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCircleEllipsis = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <circle cx={14} cy={14} r={13} stroke="#CBCBCB" strokeWidth={2} />
    <circle cx={20} cy={14} r={2} fill="#CBCBCB" />
    <circle cx={14} cy={14} r={2} fill="#CBCBCB" />
    <circle cx={8} cy={14} r={2} fill="#CBCBCB" />
  </svg>
);
export default SvgCircleEllipsis;
